import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="realty-configuration"
export default class extends Controller {
  connect() {
    const depozenSuretyBondEligible = document.getElementById('realty_security_deposit_status_eligible_to_depozen_surety_bond')
    const depozenSuretyBondUneligible = document.getElementById('realty_security_deposit_status_uneligible_to_depozen_surety_bond')
    const occupantOwnerEligible = document.getElementById('realty_home_insurance_occupant_owner_status_eligible_to_home_insurance_occupant_owner')
    const occupantOwnerUneligible = document.getElementById('realty_home_insurance_occupant_owner_status_uneligible_to_home_insurance_occupant_owner')
    const nonOccupantOwnerEligible = document.getElementById('realty_home_insurance_non_occupant_owner_status_eligible_to_home_insurance_non_occupant_owner')
    const nonOccupantOwnerUneligible = document.getElementById('realty_home_insurance_non_occupant_owner_status_uneligible_to_home_insurance_non_occupant_owner')
    const tenantOccupantEligible = document.getElementById('realty_home_insurance_tenant_occupant_status_eligible_to_home_insurance_tenant_occupant')
    const tenantOccupantUneligible = document.getElementById('realty_home_insurance_tenant_occupant_status_uneligible_to_home_insurance_tenant_occupant')

    document.addEventListener('input', (e) => {
      if (e.target.getAttribute('name') == "realty[home_insurance_occupant_owner_status]") {
        if (occupantOwnerEligible.checked) {
          nonOccupantOwnerUneligible ? (nonOccupantOwnerUneligible.checked = true) : ''
          tenantOccupantUneligible ? (tenantOccupantUneligible.checked = true) : ''
          depozenSuretyBondUneligible ? (depozenSuretyBondUneligible.checked = true) : ''
        }
      }

      if (e.target.getAttribute('name') == "realty[home_insurance_non_occupant_owner_status]") {
        if (nonOccupantOwnerEligible.checked) {
          occupantOwnerUneligible ? (occupantOwnerUneligible.checked = true) : ''
        }
      }

      if (e.target.getAttribute('name') == "realty[home_insurance_tenant_occupant_status]") {
        if (tenantOccupantEligible.checked) {
          occupantOwnerUneligible ? (occupantOwnerUneligible.checked = true) : ''
        }
      }

      if (e.target.getAttribute('name') == "realty[security_deposit_status]") {
        if (depozenSuretyBondEligible.checked) {
          occupantOwnerUneligible ? (occupantOwnerUneligible.checked = true) : ''
        }
      }
    })
  }
}
